import React, { useState, useEffect, useRef } from "react";
import { Typography } from "@material-ui/core";

export const TypingQuote = ({ text, className, style }) => {
  const [visible, setVisible] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setVisible(true);
          observer.disconnect();
        }
      },
      { threshold: 0.2 }
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  if (!text) return null;

  const words = text.split(" ");

  return (
    <>
      <style>{`
        @keyframes wordReveal {
          0% { opacity: 0; filter: blur(4px); transform: translateY(6px); }
          100% { opacity: 1; filter: blur(0); transform: translateY(0); }
        }
      `}</style>
      <Typography ref={ref} className={className} style={{ ...style }}>
        {words.map((word, i) => (
          <span
            key={i}
            style={{
              display: "inline-block",
              opacity: visible ? 1 : 0,
              animation: visible ? `wordReveal 0.4s ease forwards` : "none",
              animationDelay: visible ? `${i * 0.03}s` : "0s",
              marginRight: "0.3em",
            }}
          >
            {word}
          </span>
        ))}
      </Typography>
    </>
  );
};
